//
import { create } from 'zustand';

const usePaymentErrorModalStore = create((set) => ({
  isOpen: false,
  msg: '',

  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
  setMsg: (msg: string) => {
    set({ msg });
  },

  clean: () =>
    set({
      isOpen: false,
      msg: '',
    }),
}));

export default usePaymentErrorModalStore;
